import { snapCurrDeviceBack } from 'src/components/Planner/planner/planner';
import { connectFrames, mergeFrames } from 'src/components/Planner/planner/draganddrop';

export interface PendingFrameDrop {
    d: any;
    thisId: number;
    otherId: number;
    height: number;
    direction: string;
}

export function executeMergeFrames(frameDrop: PendingFrameDrop): Promise<void> {
    return mergeFrames(frameDrop.thisId, frameDrop.otherId, frameDrop.height, frameDrop.direction);
}

export function executeConnectFrames(frameDrop: PendingFrameDrop): Promise<void> {
    return connectFrames(frameDrop.thisId, frameDrop.otherId);
}

export function cancelFrameDrop(frameDrop: PendingFrameDrop): void {
    snapCurrDeviceBack(frameDrop.d);
}
